import { render, staticRenderFns } from "./GruposAgregados.vue?vue&type=template&id=63ddc435&"
import script from "./GruposAgregados.vue?vue&type=script&lang=js&"
export * from "./GruposAgregados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports